module.exports = __webpack_public_path__ + "media/images/icons/arrow-category-dbab9cee4726ea0790f7f75aee84cb66.svg";